import $ from 'jquery';
import { numberToString, setupLayout, showErrorDialog } from 'common.js';
import { ajaxPost, ajaxGet } from 'network/network-old.js';
import 'bootstrap/js/collapse.js';
import 'jquery-components/bootstrap-datepicker';
import 'jquery-components/bootstrap-validator';
import 'jquery-components/bootstrap-select';
import { fillBootstrapSelectWithAjax, setSelectpickerVal } from 'jquery-components/bootstrap-select';


function setupExtraSearch(bookCallback) {
    $(function () {
        // Настройка полей выбора даты
        $(".input-daterange").datepicker({
            todayBtn: "linked",
            language: language,
            startDate: minStartDate,
            orientation: "bottom auto",
            todayHighlight: true,
            autoclose: true,
            keepEmptyValues: true
        });

        // Выбор количества детей
        let showHideChildrenAges = function () {
            let childCount = parseInt($(".child-count.selectpicker").selectpicker("val"));
            $(".child").removeClass("dont-show");
            for (var child = childCount + 1; child <= 4; child++)
                $(".child" + child.toString()).addClass("dont-show");
        };
        $(".child-count.selectpicker").on("changed.bs.select", showHideChildrenAges);
        $(".child .selectpicker").on("changed.bs.select", function (e) {
            $(e.target).closest('.child').find('.child-place').prop("checked", $(e.target).selectpicker("val") > 1);
        });
        showHideChildrenAges();

        // Поле страны
        $("#countryId").on("changed.bs.select", function (e) {
            let countryId = $("#countryId").selectpicker("val");
            if (!!Number.parseInt(countryId)) {
                $("#cityId").prop("disabled", false);
                let pc = prevCityId;
                fillBootstrapSelectWithAjax("cityId", "Extra/GetCities", { CountryId: countryId }, prevCityId,
                    function () { if (pc) $("#bookingForm").validator("validate"); });
                prevCityId = undefined;
            } else {
                $("#cityId").prop("disabled", true).selectpicker("refresh");
            }
        });
        // Страна могла быть выбрана при загрузке страницы, поэтому надо сразу проверить
        if ($("#countryId").val())
            setTimeout(function () { $("#countryId").trigger("changed.bs.select"); }, 500);
        else
            prevCityId = null;
        $("#cityId").prop("disabled", true);

        // Поле страны
        $("#ServiceClassId").on("changed.bs.select", function (e) {
            let classId = $("#ServiceClassId").selectpicker("val");
            if (!!Number.parseInt(classId)) {
                $("#ServiceId").prop("disabled", false);
                let pc = prevServiceId;
                fillBootstrapSelectWithAjax("ServiceId", "Extra/GetServices", { ClassId: classId }, prevServiceId,
                    function () { if (pc) $("#bookingForm").validator("validate"); });
                prevServiceId = undefined;
            } else {
                $("#ServiceId").prop("disabled", true).selectpicker("refresh");
            }
        });
        // Страна могла быть выбрана при загрузке страницы, поэтому надо сразу проверить
        if ($("#ServiceClassId").val())
            setTimeout(function () { $("#ServiceClassId").trigger("changed.bs.select"); }, 500);
        else
            prevCityId = null;
        $("#ServiceId").prop("disabled", true);

        // Очистка полей
        $("#clrBtn").click(function (evt) {
            evt.preventDefault();
            $(".adult-count").selectpicker("val", 2);
            $(".child-count").selectpicker("val", 0);
            $(".child-count").trigger("changed.bs.select");
            $("#cityId").val(null);
            setSelectpickerVal($("#countryId"), null);
            $("#ServiceId").val(null);
            setSelectpickerVal($("#ServiceClassId"), null);
            $("#beginFld").datepicker("setDate", null);
            $("#endFld").datepicker("setDate", null);
            $("input[name='pt'][value='0']").prop("checked", true);
            $(".help-block.with-errors").empty();
        });

        // Пересчет стоимости
        let recalculateSums = function () {
            let blocks = [".extras-div"];
            for (let block = 0; block < blocks.length; block++) {
                let sum = 0;
                $(blocks[block] + " tr:not(.dont-show) input[type='checkbox']:checked").each(function (idx, elt) {
                    sum += parseFloat($(elt).closest("tr[data-sum]").attr("data-sum"));
                });
                $(blocks[block] + " .extra-price-summ.total span").text(numberToString(sum, 2));
                $(blocks[block] + " .extra-price-summ.avg span").text(numberToString(sum / totalPersons, 2));
            }
        };
        $("#ExtraForm input[type='checkbox']").change(recalculateSums);

        // Добавление в корзину
        $(".add-to-cart").click(function (evt) {
            evt.preventDefault();
            addExtrasToCart(bookCallback);
        });
        // Добавление в корзину
        $(".cart-btn").click(function (evt) {
            evt.preventDefault();
            addExtraToCart($(this).closest("tr[data-serialized]"), bookCallback);
        });
    });
}

// Добавляет выделенные экскурсии и программы в корзину
function addExtrasToCart(bookCallback) {
    const $excCkBoxes = $(".extras-div input[type='checkbox']:checked");
    if (!$excCkBoxes.length) {
        showErrorDialog(window._LANGUAGE_STRINGS["EXTRA_ERROR_EMPTY_SELECTION"]);
        return;
    }

    var cartData = {
        searchParamsSerialized: searchParamsSerialized,
        extrasSerialized: $(".extras-div input[type='checkbox']:checked")
            .closest("tr[data-serialized]").map(function (idx, elt) { return $(elt).attr("data-serialized"); })
            .get().join(),
    };

    if (typeof bookCallback == 'function')
        bookCallback(cartData);
    else
        addExtraServicesToCart(cartData);
}
function addExtraToCart($transfer, bookCallback) {
    var cartData = {
        searchParamsSerialized: searchParamsSerialized,
        extrasSerialized: $transfer.attr("data-serialized")
    };

    if (typeof bookCallback == 'function')
        bookCallback(cartData);
    else
        addExtraServicesToCart(cartData);
}

function addExtraServicesToCart(cartData, replaceCart) {
    if (replaceCart)
        cartData.replaceCart = true;
    ajaxPost(appBase + "Extra/AddToCart", cartData, function (data) {
        if (data && data.errorCode && data.errorCode.indexOf('CART_CONFLICT') === 0 && window.showCartConflictModal) {
            var reason = data.errorCode === 'CART_CONFLICT_CURRENCY' ? 'currency' : 'service';
            window.showCartConflictModal({
                reason: reason,
                onReplace: function () { addExtraServicesToCart(cartData, true); }
            });
            return;
        }
        window.location = appBase + "Cart";
    });
}

export {
    setupLayout,
    setupExtraSearch,
}
